// extracted by mini-css-extract-plugin
module.exports = {"icons":"ClientUnitPriceTableRow__icons--12ut0"};